// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1DfnV","label":"SetPasswdForm_label__3o5nx"};